/** Stack a label on top of an input — used everywhere in the wizard. */
export function LabeledInput(props: {
  label: string;
  value: string | number;
  onChange: (v: string) => void;
  placeholder?: string;
  type?: string;
  min?: number;
  max?: number;
}) {
  return (
    <label className="flex flex-col gap-1">
      <span className="label">{props.label}</span>
      <input
        className="input"
        value={props.value}
        type={props.type ?? "text"}
        min={props.min}
        max={props.max}
        placeholder={props.placeholder ?? ""}
        onChange={(e) => props.onChange(e.target.value)}
      />
    </label>
  );
}
